import "./gatewayIntegrationController"
import "./gatewayIntegration.less"